import { FxSeoPairEligibility, AdrRecord, DeliverableP4 } from '../types';

export const SEO_ELIGIBLE_PAIRS: FxSeoPairEligibility[] = [
  {
    pair: 'USD-EUR',
    base: 'USD',
    quote: 'EUR',
    searchVolumeScore: 100,
    dataQualityScore: 99.8,
    status: 'INDEXABLE',
    canonicalUrl: 'https://yamoopay.com/en/currency/usd-to-eur',
    hreflang: {
      'en': 'https://yamoopay.com/en/currency/usd-to-eur',
      'fr': 'https://yamoopay.com/fr/devises/usd-vers-eur',
      'es': 'https://yamoopay.com/es/divisas/usd-a-eur',
      'de': 'https://yamoopay.com/de/waehrung/usd-zu-eur',
      'x-default': 'https://yamoopay.com/en/currency/usd-to-eur',
    },
    titleTemplate: 'USD to EUR Exchange Rate & Converter | YamooPay',
    metaDescription: 'Convert US Dollars to Euros at the verified mid-market exchange rate. View institutional ECB reference rates, historical charts, and transparent fee comparison.',
    uniqueInsights: [
      'The EUR/USD pair is the most actively traded currency corridor globally, accounting for over 22% of total daily global forex turnover.',
      'YamooPay integrates European Central Bank (ECB) reference rates published at 16:00 CET alongside commercial wholesale feeds.',
      'Sovereign eurozone jurisdictions share the single currency, governed under strict Maastricht fiscal stability rules.',
    ],
    lastmod: '2026-08-24T00:00:00Z',
  },
  {
    pair: 'EUR-USD',
    base: 'EUR',
    quote: 'USD',
    searchVolumeScore: 98,
    dataQualityScore: 99.8,
    status: 'INDEXABLE',
    canonicalUrl: 'https://yamoopay.com/en/currency/eur-to-usd',
    hreflang: {
      'en': 'https://yamoopay.com/en/currency/eur-to-usd',
      'fr': 'https://yamoopay.com/fr/devises/eur-vers-usd',
      'es': 'https://yamoopay.com/es/divisas/eur-a-usd',
      'de': 'https://yamoopay.com/de/waehrung/eur-zu-usd',
      'x-default': 'https://yamoopay.com/en/currency/eur-to-usd',
    },
    titleTemplate: 'EUR to USD Exchange Rate & Converter | YamooPay',
    metaDescription: 'Convert Euros to US Dollars with live mid-market rates, Federal Reserve H.10 comparisons, and verified historical time series.',
    uniqueInsights: [
      'Direct reciprocal cross-rate derived from primary wholesale liquidity pools with mathematical precision.',
      'Provides actionable benchmark data for European exporters and transatlantic trade settlements.',
    ],
    lastmod: '2026-08-24T00:00:00Z',
  },
  {
    pair: 'GBP-USD',
    base: 'GBP',
    quote: 'USD',
    searchVolumeScore: 94,
    dataQualityScore: 99.6,
    status: 'INDEXABLE',
    canonicalUrl: 'https://yamoopay.com/en/currency/gbp-to-usd',
    hreflang: {
      'en': 'https://yamoopay.com/en/currency/gbp-to-usd',
      'fr': 'https://yamoopay.com/fr/devises/gbp-vers-usd',
      'es': 'https://yamoopay.com/es/divisas/gbp-a-usd',
      'x-default': 'https://yamoopay.com/en/currency/gbp-to-usd',
    },
    titleTemplate: 'GBP to USD Exchange Rate (Cable) | YamooPay',
    metaDescription: 'Convert British Pounds to US Dollars using Cable mid-market rates verified against Bank of England statutory fixings.',
    uniqueInsights: [
      'Known historically as "Cable" due to the 19th-century transatlantic telegraph line linking the London and New York exchanges.',
      'Subject to Bank of England Monetary Policy Committee (MPC) interest rate decisions.',
    ],
    lastmod: '2026-08-24T00:00:00Z',
  },
  {
    pair: 'USD-JPY',
    base: 'USD',
    quote: 'JPY',
    searchVolumeScore: 92,
    dataQualityScore: 99.5,
    status: 'INDEXABLE',
    canonicalUrl: 'https://yamoopay.com/en/currency/usd-to-jpy',
    hreflang: {
      'en': 'https://yamoopay.com/en/currency/usd-to-jpy',
      'fr': 'https://yamoopay.com/fr/devises/usd-vers-jpy',
      'x-default': 'https://yamoopay.com/en/currency/usd-to-jpy',
    },
    titleTemplate: 'USD to JPY Exchange Rate & Yen Converter | YamooPay',
    metaDescription: 'Convert US Dollars to Japanese Yen with zero-minor-unit currency formatting and Bank of Japan reference benchmarks.',
    uniqueInsights: [
      'Japanese Yen operates with 0 minor decimal units in ISO 4217, preventing truncation artifacts.',
      'Primary benchmark currency for Asian trade finance and global carry trade flows.',
    ],
    lastmod: '2026-08-24T00:00:00Z',
  },
  {
    pair: 'USD-CAD',
    base: 'USD',
    quote: 'CAD',
    searchVolumeScore: 89,
    dataQualityScore: 99.7,
    status: 'INDEXABLE',
    canonicalUrl: 'https://yamoopay.com/en/currency/usd-to-cad',
    hreflang: {
      'en': 'https://yamoopay.com/en/currency/usd-to-cad',
      'fr': 'https://yamoopay.com/fr/devises/usd-vers-cad',
      'x-default': 'https://yamoopay.com/en/currency/usd-to-cad',
    },
    titleTemplate: 'USD to CAD Exchange Rate & Loonie Converter | YamooPay',
    metaDescription: 'Convert US Dollars to Canadian Dollars with Bank of Canada reference rates and North American cross-border payment insights.',
    uniqueInsights: [
      'Heavily influenced by USMCA bilateral trade flows and commodity energy market benchmarks.',
      'Bank of Canada publishes daily 16:30 ET official rates used for Canadian Revenue Agency (CRA) customs tax reporting.',
    ],
    lastmod: '2026-08-24T00:00:00Z',
  },
  {
    pair: 'USD-INR',
    base: 'USD',
    quote: 'INR',
    searchVolumeScore: 91,
    dataQualityScore: 99.4,
    status: 'INDEXABLE',
    canonicalUrl: 'https://yamoopay.com/en/currency/usd-to-inr',
    hreflang: {
      'en': 'https://yamoopay.com/en/currency/usd-to-inr',
      'x-default': 'https://yamoopay.com/en/currency/usd-to-inr',
    },
    titleTemplate: 'USD to INR Exchange Rate & Rupee Converter | YamooPay',
    metaDescription: 'Convert USD to Indian Rupee (INR) at verified Reserve Bank of India (RBI) mid-market rates for remittance transparency.',
    uniqueInsights: [
      'India is the worlds largest remittance recipient market, with over $120B annual inward flows.',
      'RBI publishes reference rates derived from daily domestic interbank fixing windows.',
    ],
    lastmod: '2026-08-24T00:00:00Z',
  },
  {
    pair: 'EUR-XAF',
    base: 'EUR',
    quote: 'XAF',
    searchVolumeScore: 82,
    dataQualityScore: 100.0,
    status: 'INDEXABLE',
    canonicalUrl: 'https://yamoopay.com/en/currency/eur-to-xaf',
    hreflang: {
      'en': 'https://yamoopay.com/en/currency/eur-to-xaf',
      'fr': 'https://yamoopay.com/fr/devises/eur-vers-xaf',
      'x-default': 'https://yamoopay.com/en/currency/eur-to-xaf',
    },
    titleTemplate: 'EUR to XAF Exchange Rate (Fixed CFA Peg) | YamooPay',
    metaDescription: 'Convert Euro to Central African CFA Franc with statutory parity (1 EUR = 655.957 XAF) guaranteed under BEAC monetary treaties.',
    uniqueInsights: [
      'XAF maintains an unconditional, legally binding fixed peg with the Euro at 1 EUR = 655.957 XAF guaranteed by the French Treasury.',
      'CEMAC member states (Cameroon, Gabon, Chad, Congo, CAR, Equatorial Guinea) operate zero minor units for cash transactions.',
    ],
    lastmod: '2026-08-24T00:00:00Z',
  },
  {
    pair: 'USD-NGN',
    base: 'USD',
    quote: 'NGN',
    searchVolumeScore: 87,
    dataQualityScore: 98.6,
    status: 'INDEXABLE',
    canonicalUrl: 'https://yamoopay.com/en/currency/usd-to-ngn',
    hreflang: {
      'en': 'https://yamoopay.com/en/currency/usd-to-ngn',
      'x-default': 'https://yamoopay.com/en/currency/usd-to-ngn',
    },
    titleTemplate: 'USD to NGN Exchange Rate & Official NAFEM Converter | YamooPay',
    metaDescription: 'Convert US Dollars to Nigerian Naira with official Central Bank of Nigeria (CBN) NAFEM autonomous FX market rates.',
    uniqueInsights: [
      'CBN unified the official and autonomous FX windows under the Nigerian Autonomous Foreign Exchange Market (NAFEM).',
      'YamooPay explicitly labels official reference feeds to ensure maximum financial clarity.',
    ],
    lastmod: '2026-08-24T00:00:00Z',
  },
];

// Architecture Decision Records (ADRs) for Prompt 04
export const FX_ADR_RECORDS: AdrRecord[] = [
  {
    id: 'ADR-FX-001',
    title: 'Canonical Rate Model and Zero-Float Numeric Representation',
    status: 'ACCEPTED',
    context: 'Standard IEEE 754 floating point arithmetic introduces rounding drift (e.g. 0.1 + 0.2 = 0.30000000000000004). Financial conversions across 170+ currency pairs demand exact mathematical determinism.',
    decision: 'All database rates are stored as PostgreSQL NUMERIC(18,8) and conversion calculations utilize integer scaled precision math with ISO 4217 minor unit rounding policies.',
    consequences: [
      'Eliminates rounding inconsistencies between frontend and backend.',
      'Slight CPU serialization overhead mitigated by fast typed arithmetic helpers.',
    ],
    compliance: 'ISO 4217 & IFRS 9 Financial Instrument Presentation Standards',
  },
  {
    id: 'ADR-FX-002',
    title: 'Multi-Source Provider Strategy with Strict Anti-Vendor Lock-in',
    status: 'ACCEPTED',
    context: 'Directly coupling frontend components to external third-party API JSON structures (e.g. Fixer, CurrencyLayer) risks vendor lock-in, unannounced schema breaks, and data licensing exposure.',
    decision: 'Implement FxProviderAdapter abstraction pattern. All external feeds are normalized into canonical ExchangeRateObservation before writing to PostgreSQL 18 System of Record.',
    consequences: [
      'Seamless hot-swapping between Primary Commercial, Central Bank, and Secondary providers without client downtime.',
      'Zero vendor-specific keys or payloads exposed to browser clients.',
    ],
    compliance: 'YamooPay Zero Trust Data Architecture',
  },
  {
    id: 'ADR-FX-003',
    title: 'Last Known Good (LKG) Fallback & Honest Freshness Provenance',
    status: 'ACCEPTED',
    context: 'When upstream providers experience outages or network latency, serving stale data as "live" deceives users, while throwing hard errors destroys utility.',
    decision: 'Enforce honest provenance. When primary feeds fail, the engine serves previously validated Last Known Good (LKG) observations accompanied by prominent UI timestamp badges and disclaimer banners.',
    consequences: [
      'Unbroken uptime for conversion tools even during cloud provider outages.',
      'Transparent disclosure prevents legal liability and user distrust.',
    ],
    compliance: 'Consumer Financial Protection Bureau (CFPB) Transparency Guidelines',
  },
  {
    id: 'ADR-FX-004',
    title: 'PostgreSQL 18 Timeseries Storage & Aggregation Architecture',
    status: 'ACCEPTED',
    context: 'Storing high-frequency ticks across 170+ currencies produces millions of rows. Querying years of historical points on raw tables degrades client response times.',
    decision: 'Implement time-partitioned tables (monthly partitions) with pre-computed continuous aggregate materialized views for 1D, 1W, 1M, and 1Y intervals.',
    consequences: [
      'Sub-15ms historical chart queries regardless of dataset age.',
      'Automated data retention policies pruning granular raw ticks older than 90 days while preserving daily aggregates indefinitely.',
    ],
    compliance: 'PostgreSQL 18 Declarative Partitioning Standard',
  },
  {
    id: 'ADR-FX-005',
    title: 'Programmatic SEO Pair Eligibility Engine & Anti-Spam Gate',
    status: 'ACCEPTED',
    context: '170 currencies generate 28,730 directional pairs. Auto-indexing every pair in 6 languages creates 170,000+ low-value programmatic pages triggering search engine spam penalties.',
    decision: 'Enforce strict CurrencyPairSeoEligibility scoring. Pages are only set to INDEXABLE if they meet minimum search volume thresholds, verified data quality scores (>98%), and unique data-driven explanatory content.',
    consequences: [
      'Protects domain authority and avoids crawl budget waste.',
      'Dynamic NOINDEX gating if data freshness or provider health degrades.',
    ],
    compliance: 'Google Search Essentials & Quality Rater Guidelines',
  },
];

// Deliverables A to AL formalized for Prompt 04
export const PROMPT_04_DELIVERABLES: DeliverableP4[] = [
  {
    code: 'A',
    titleEn: 'Currency Product Architecture',
    titleFr: 'Architecture Produit Devises',
    category: 'Domain & Providers',
    summary: 'Comprehensive Currency Intelligence Platform spanning conversion, historical time series, alert monitoring, and currency profile hubs.',
    details: [
      'Multi-purpose platform serving consumers, cross-border remote workers, multinational finance teams, and travelers.',
      'Clear conceptual separation between Mid-Market Wholesale, Official Reference, and Retail Money Transfer rates.',
    ],
    architectureNotes: 'Single System of Record with modular frontend consumption layers.',
  },
  {
    code: 'B',
    titleEn: 'FX Domain Architecture & Clean Bounded Contexts',
    titleFr: 'Architecture du Domaine FX & Contextes Délimités',
    category: 'Domain & Providers',
    summary: 'Isolated domain model decoupling external payload structures from canonical financial state.',
    details: [
      'Strict separation of Raw Payload Ingestion, Quality Validation, Canonical Normalization, and Read Model Serving.',
      'Implements DDD (Domain-Driven Design) entities for Currencies, Pairs, Observations, and Alerts.',
    ],
    architectureNotes: 'Zero vendor schema contamination across UI components.',
  },
  {
    code: 'C',
    titleEn: 'Four-Tier Multi-Source Strategy',
    titleFr: 'Stratégie Multi-Sources à 4 Paliers',
    category: 'Domain & Providers',
    summary: 'Hierarchical sourcing combining Institutional Central Banks, Commercial Market Feeds, Secondary Fallbacks, and Sovereign Treaties.',
    details: [
      'Tier A: European Central Bank (ECB), Federal Reserve, Bank of England, Bank of Canada for official fixings.',
      'Tier B: Commercial wholesale market liquidity for high frequency 170+ currency coverage.',
      'Tier C: Secondary failover provider for redundancy and cross-provider anomaly detection.',
      'Tier D: Sovereign fixed peg registries (e.g. CEMAC/WAEMU CFA Franc, GCC Dollar pegs).',
    ],
    architectureNotes: 'Automated consensus checks and variance alarm triggers.',
  },
  {
    code: 'D',
    titleEn: 'FxProviderAdapter Interface & Zero Lock-in',
    titleFr: 'Interface FxProviderAdapter & Zéro Verrouillage',
    category: 'Domain & Providers',
    summary: 'Standardized adapter contract enabling zero-downtime provider hot-swapping.',
    details: [
      'Methods: getLatestRates(), getPairRate(), getHistoricalRate(), getTimeSeries(), healthCheck(), normalize().',
      'Eliminates hardcoded provider endpoints or JSON response assumptions.',
    ],
    architectureNotes: 'Adapter pattern with automated JSON schema validation.',
  },
  {
    code: 'E',
    titleEn: '170+ Global Currency Coverage Strategy',
    titleFr: 'Stratégie de Couverture 170+ Devises',
    category: 'Domain & Providers',
    summary: 'Full ISO 4217 world currency registry clearly categorized by monetary nature.',
    details: [
      'Fiat currencies: USD, EUR, GBP, JPY, CAD, CHF, AUD, INR, SGD, CNY, ZAR, NGN, XAF, XOF, etc.',
      'Special Monetary Units: IMF Special Drawing Rights (XDR).',
      'Precious Metals: Gold (XAU), Silver (XAG) with distinct unit tags.',
      'Future-ready digital asset segregation preventing conflation with sovereign fiat.',
    ],
    architectureNotes: 'Global-first prioritization without regional bias.',
  },
  {
    code: 'F',
    titleEn: 'Current Rate Architecture & Honest Provenance',
    titleFr: 'Architecture du Taux Actuel & Traçabilité',
    category: 'Domain & Providers',
    summary: 'Strict ban on fake "Real-time" marketing claims in favor of verifiable freshness tiers.',
    details: [
      'Six explicit freshness statuses: REAL_TIME, NEAR_REAL_TIME, REFERENCE, DAILY, HISTORICAL, LAST_KNOWN_GOOD.',
      'Transparent UI labels: "Current rate", "Mid-market rate", "Reference rate", "Last verified at 14:32 UTC".',
    ],
    architectureNotes: 'Confidence scoring and timestamp verification on all visual displays.',
  },
  {
    code: 'G',
    titleEn: 'Shortest Trusted Path Cross Rate Engine',
    titleFr: 'Moteur de Taux Croisés au Plus Court Chemin Fiable',
    category: 'Precision & Engines',
    summary: 'Deterministic derivation of non-USD and non-EUR cross rates with complete mathematical lineage.',
    details: [
      'Reciprocal calculation (1 / rate) marked as derived with precision preservation.',
      'Triangular arbitrage consistency check (A/B × B/C ≈ A/C) with automatic variance alerting.',
      'Selection based on source authority, freshness, and minimal transformation hops.',
    ],
    architectureNotes: 'Complete derivation path tracked in database record.',
  },
  {
    code: 'H',
    titleEn: 'Historical FX Engine & Date Lookups',
    titleFr: 'Moteur Historique FX & Recherche par Date',
    category: 'Precision & Engines',
    summary: 'Point-in-time exact past rate lookups and time series analytics.',
    details: [
      'Interactive date conversions: "What was 1,000 USD worth in EUR on Jan 5, 2025?".',
      'Non-business day fallback policy transparently citing preceding Friday official fixings.',
      'Timeframes: 1D, 5D, 1M, 3M, 6M, YTD, 1Y, 5Y, MAX with automated multi-resolution downsampling.',
    ],
    architectureNotes: 'Prevents sending thousands of raw ticks to browser viewports.',
  },
  {
    code: 'I',
    titleEn: 'Data Freshness & Hard Expiry Policies',
    titleFr: 'Politique de Fraîcheur & Expiration Stricte',
    category: 'Precision & Engines',
    summary: 'Granular TTL policies configured per source tier and market volatility class.',
    details: [
      'Major pairs: Fresh for 5 min, aging at 15 min, stale at 60 min.',
      'Exotic & daily official reference feeds: Fresh for 24h.',
      'Hard expiry safety mode displaying "Rate temporarily unavailable" rather than expired values.',
    ],
    architectureNotes: 'Automated background stale data sweeps and LKG fallbacks.',
  },
  {
    code: 'J',
    titleEn: '7-Dimension Data Quality Engine',
    titleFr: 'Moteur de Qualité des Données à 7 Dimensions',
    category: 'Precision & Engines',
    summary: 'Pre-promotion validation engine checking Completeness, Validity, Uniqueness, Consistency, Timeliness, Accuracy, and Referential Integrity.',
    details: [
      'Outlier rejection: flags sudden >20% single-tick spikes or 100x scale factor errors.',
      'Automated quarantine routing with single-click operator triage.',
    ],
    architectureNotes: 'Integrated with Prompt 03 PostgreSQL Governance rules.',
  },
  {
    code: 'K',
    titleEn: 'Automated Provider Failover & Failback',
    titleFr: 'Basculement & Retour Automatique des Fournisseurs',
    category: 'Precision & Engines',
    summary: 'Resilient multi-provider failover workflow with stabilization verification before failback.',
    details: [
      'Primary failure triggers automated validation of Secondary Tier C feed and promotion.',
      'Failback requires 5 consecutive healthy ingestions without variance to avoid flapping.',
    ],
    architectureNotes: 'Operations cockpit provides manual override capabilities.',
  },
  {
    code: 'L',
    titleEn: 'Tiered Caching & Invalidation Architecture',
    titleFr: 'Architecture de Cache Hiérarchisée & Invalidation',
    category: 'Precision & Engines',
    summary: 'Four-tier cache hierarchy absorbing 96%+ of read traffic.',
    details: [
      'Tier 1: In-memory application cache for hot major pairs.',
      'Tier 2: Distributed Redis cache for shared multi-container state.',
      'Tier 3: CDN edge caching with stale-while-revalidate headers.',
      'Tier 4: Browser Service Worker cache for offline PWA conversions.',
    ],
    architectureNotes: 'Selective pair invalidation without flushing the entire global cache.',
  },
  {
    code: 'M',
    titleEn: 'Mathematical Precision & Decimal Calculation',
    titleFr: 'Précision Mathématique & Calcul Décimal',
    category: 'Precision & Engines',
    summary: 'Standardized 1 BASE = X QUOTE convention with zero JS float drift.',
    details: [
      'High intermediate precision integer math scaling.',
      'Display formatting respecting ISO 4217 minor units (0 for JPY/XAF, 2 for USD/EUR, 3 for BHD/KWD).',
      'Dynamic precision preservation for micro-unit exchange rates (e.g. VND, IDR) avoiding $0.00 truncation.',
    ],
    architectureNotes: 'Unit-tested against bank settlement edge cases.',
  },
  {
    code: 'N',
    titleEn: 'Currency Metadata Model & Pegging Registries',
    titleFr: 'Modèle de Métadonnées & Registre des Parités',
    category: 'Precision & Engines',
    summary: 'Rich metadata tracking sovereign central banks, currency unions, and official treaty peg rules.',
    details: [
      'Separates currency identity from national flags (e.g. EUR, XAF, USD in Ecuador).',
      'Tracks historical peg changes, band variances, and monetary treaties.',
    ],
    architectureNotes: 'Versioned rule records with effective dates.',
  },
  {
    code: 'O',
    titleEn: 'PostgreSQL 18 Database Extensions',
    titleFr: 'Extensions de Base de Données PostgreSQL 18',
    category: 'Precision & Engines',
    summary: '17 normalized tables covering observations, cross-rate derivations, aggregates, freshness policies, and rate alerts.',
    details: [
      'UUIDv7 primary keys for natural temporal indexing.',
      'Partitioned tables for exchange_rate_observation and exchange_rate_aggregate.',
    ],
    architectureNotes: 'Complete DDL schema viewable in Command Center.',
  },
  {
    code: 'P',
    titleEn: 'Entity Relationship Diagram (ERD)',
    titleFr: 'Schéma Entité-Relation (ERD)',
    category: 'Precision & Engines',
    summary: 'Normalized relational architecture linking currencies, providers, observations, derivations, and alerts.',
    details: [
      'Foreign key constraints enforcing referential integrity with CASCADE safety.',
      'Audit logging on all manual override interventions.',
    ],
    architectureNotes: 'Visualizable in PostgreSQL Command Center.',
  },
  {
    code: 'Q',
    titleEn: 'Internal & Public-Ready API Contracts',
    titleFr: 'Contrats d’API Internes & Prêts pour le Public',
    category: 'Precision & Engines',
    summary: 'Standardized RESTful endpoints with strict schema validation and rate limiting.',
    details: [
      'GET /api/fx/latest?base=USD&quote=EUR',
      'GET /api/fx/convert?amount=1000&from=USD&to=EUR',
      'GET /api/fx/history?base=USD&quote=EUR&timeframe=1M',
      'GET /api/fx/currencies',
      'POST /api/fx/alerts',
    ],
    architectureNotes: 'Server-side proxying keeping all external API keys secret.',
  },
  {
    code: 'R',
    titleEn: 'Background Ingestion Jobs & Cron Schedulers',
    titleFr: 'Tâches d’Ingestion en Arrière-Plan & Planificateurs Cron',
    category: 'Operations & ADRs',
    summary: 'Distributed job coordination with advisory locking and idempotent historical backfill.',
    details: [
      'currencyMetadataSync, latestRatesSync (every 2m), officialReferenceSync (daily 16:15 CET), anomalyCheck, alertEvaluator.',
      'Exponential backoff with jitter on network failures.',
    ],
    architectureNotes: 'Dokploy container scaling safe with PostgreSQL advisory locks.',
  },
  {
    code: 'S',
    titleEn: 'Main Currency Converter UX',
    titleFr: 'UX du Convertisseur de Devises Principal',
    category: 'UX & Visualizations',
    summary: 'Instantaneous calculation, single-click currency swap, copy result, and popular amount matrix.',
    details: [
      'Zero unnecessary Calculate button clicks; reactive calculation on amount or currency change.',
      'Displays inverse rate, estimated retail spread savings, and data freshness provenance.',
      'Popular amount matrix: 1, 10, 50, 100, 500, 1,000, 5,000 units + inverse table.',
    ],
    architectureNotes: 'Shareable URL state support (?from=USD&to=EUR&amount=1000).',
  },
  {
    code: 'T',
    titleEn: 'Currency Pair Deep-Dive Pages UX',
    titleFr: 'UX des Pages Approfondies de Paires de Devises',
    category: 'UX & Visualizations',
    summary: 'Dedicated pair landing hubs featuring live bids/asks, 52-week ranges, methodology, and money transfer comparison bridges.',
    details: [
      'Structured conversion tables and recent movement telemetry.',
      'Transparent bridge: "Sending money internationally? Compare transfer providers" without deceptive fake savings.',
    ],
    architectureNotes: 'Mobile-first layout with desktop secondary analytics.',
  },
  {
    code: 'U',
    titleEn: 'Currency Profile Hubs UX',
    titleFr: 'UX des Profils de Devises',
    category: 'UX & Visualizations',
    summary: 'Comprehensive currency overview pages with central bank info, sovereign territory coverage, and top corridor rankings.',
    details: [
      'Avoids flag overload by prioritizing ISO codes, monetary authorities, and economic data.',
      'Covers both major reserve currencies and regional currency unions.',
    ],
    architectureNotes: 'Filterable directory with instant search.',
  },
  {
    code: 'V',
    titleEn: 'Accessible Historical FX Charts UX',
    titleFr: 'UX des Graphiques Historiques Accessibles',
    category: 'UX & Visualizations',
    summary: 'Lightweight SVG chart visualization with hover crosshair, statistical metrics, and non-misleading color tones.',
    details: [
      'Displays period high, low, average, percentage change, and volatility.',
      'Avoids naive green=good/red=bad bias on forex shifts.',
      'Accessible text summary for screen readers.',
    ],
    architectureNotes: 'Lazy loaded after the primary converter to ensure instant initial paint.',
  },
  {
    code: 'W',
    titleEn: 'Favorites & Custom Watchlist',
    titleFr: 'Favoris & Liste de Surveillance Personnalisée',
    category: 'UX & Visualizations',
    summary: 'Pin favorite pairs with 24h movement badges and quick swap & convert actions.',
    details: [
      'Anonymous users: persistent localStorage state.',
      'Signed-in users: cloud synchronized account watchlist.',
    ],
    architectureNotes: 'Instant UI feedback with smooth animations.',
  },
  {
    code: 'X',
    titleEn: 'Exchange Rate Alerts & Notifications',
    titleFr: 'Alertes de Taux de Change & Notifications',
    category: 'UX & Visualizations',
    summary: 'Configurable rate threshold alerts with anti-flapping hysteresis and transparent disclaimers.',
    details: [
      'Conditions: ABOVE, BELOW, PERCENT_CHANGE, DAILY_SUMMARY.',
      '0.25% hysteresis buffer and 60-minute cooldown preventing notification storms.',
      'Clear disclaimer: informational alerts, not trading or investment advice.',
    ],
    architectureNotes: 'Multi-channel support: in-app notifications, email, and web push.',
  },
  {
    code: 'Y',
    titleEn: 'Offline PWA Mode & Honest Caching',
    titleFr: 'Mode Hors-Ligne PWA & Cache Transparent',
    category: 'UX & Visualizations',
    summary: 'Uninterrupted conversion capabilities when disconnected from the network.',
    details: [
      'Displays explicit "Offline" banner with exact timestamp: "Using last verified rate saved on your device (2 hours ago)".',
      'Never presents cached values as live when offline.',
    ],
    architectureNotes: 'Service Worker cache versioning with automatic refresh on reconnect.',
  },
  {
    code: 'Z',
    titleEn: 'Deterministic Smart Search & NLP Parsing',
    titleFr: 'Recherche Intelligente Déterministe & Analyse NLP',
    category: 'UX & Visualizations',
    summary: 'Instant natural language query parser for fast currency conversions in the command palette.',
    details: [
      'Handles queries like "100 dollars in euros", "EUR USD history", "500 CAD to USD", "250000 XAF to EUR".',
      'Zero LLM latency: deterministic regex and alias token parser.',
    ],
    architectureNotes: 'Integrated with global ⌘K command bar.',
  },
  {
    code: 'AA',
    titleEn: 'Programmatic SEO Architecture & Anti-Spam Gate',
    titleFr: 'Architecture SEO Programmatique & Barrière Anti-Spam',
    category: 'SEO & Distribution',
    summary: 'High-value search acquisition engine avoiding mass low-quality page generation.',
    details: [
      'Controlled URL structure: /en/currency/usd-to-eur.',
      'Query parameter indexing controls ensuring ?amount= and ?date= variants do not pollute index.',
      'Schema.org structured data (Organization, WebSite, BreadcrumbList, FinancialProduct).',
    ],
    architectureNotes: 'Strict canonicalization and noindex safeguards on degraded data.',
  },
  {
    code: 'AB',
    titleEn: 'Currency Pair Eligibility Scoring Engine',
    titleFr: 'Moteur d’Éligibilité SEO des Paires de Devises',
    category: 'SEO & Distribution',
    summary: 'Algorithmic scoring determining which pairs qualify for search indexation.',
    details: [
      'Metrics: search demand, source coverage depth, data quality score, and unique localized value.',
      'Status lifecycle: DISCOVERED → DRAFT → ELIGIBLE → INDEXABLE → NOINDEX / RETIRED.',
    ],
    architectureNotes: 'Search Console telemetry feedback loop.',
  },
  {
    code: 'AC',
    titleEn: 'International SEO, Hreflang & Multi-Locale URLs',
    titleFr: 'SEO International, Balises Hreflang & URLs Multi-Locales',
    category: 'SEO & Distribution',
    summary: 'Bidirectional hreflang alternate mapping across English, French, Spanish, German, and Italian.',
    details: [
      'Clean localized URL slugs without IP-based text replacement on identical URLs.',
      'x-default fallbacks for global visitors.',
    ],
    architectureNotes: 'Validated for 100% crawl consistency.',
  },
  {
    code: 'AD',
    titleEn: 'Sharded XML Sitemap Strategy',
    titleFr: 'Stratégie de Sitemap XML Segmenté',
    category: 'SEO & Distribution',
    summary: 'Scalable sitemap architecture segmenting currency pairs, currency profiles, and financial guides.',
    details: [
      'Segmented by locale and entity type (e.g. sitemap-currency-pairs-en-1.xml).',
      'Accurate lastmod headers tied to substantive content and methodology updates.',
    ],
    architectureNotes: 'Excludes all noindex and quarantined pair URLs.',
  },
  {
    code: 'AE',
    titleEn: 'Exchange Rate Operations Command Center',
    titleFr: 'Centre de Commandement des Opérations FX',
    category: 'Operations & ADRs',
    summary: 'Comprehensive administration and monitoring cockpit in crisp Light Mode.',
    details: [
      'Live KPIs: Primary/Secondary source health, failover state, quota burn rate, cache hit ratio.',
      'Pair Health inspector, Cross-Source Variance Analyzer, Conflict Center, and Quarantine triage.',
      'Granular kill switches for providers, pairs, alerts, and historical ingestion.',
    ],
    architectureNotes: 'Integrated with YamooPay Security & RBAC models.',
  },
  {
    code: 'AF',
    titleEn: 'Data Observability & SLO Management',
    titleFr: 'Observabilité des Données & Gestion des SLOs',
    category: 'Operations & ADRs',
    summary: 'Real-time telemetry and latency tracking across the entire ingestion and conversion pipeline.',
    details: [
      'Metrics: fx_ingestion_success, fx_provider_latency, fx_stale_pairs, fx_cache_hit_rate.',
      'SLO Target: 99.5% of major pair requests served within advertised freshness thresholds.',
    ],
    architectureNotes: 'Correlation IDs linking user requests to raw source observation IDs.',
  },
  {
    code: 'AG',
    titleEn: 'Security & API Key Isolation',
    titleFr: 'Sécurité & Isolation des Clés API',
    category: 'Operations & ADRs',
    summary: 'Strict server-side key management preventing browser credential leakage.',
    details: [
      'All commercial provider tokens remain isolated in backend server environment variables.',
      'Strict rate limiting on conversion and historical API endpoints.',
    ],
    architectureNotes: 'No secret tokens stored in PWA or client-side storage.',
  },
  {
    code: 'AH',
    titleEn: 'Privacy Controls & Zero Personal Logging',
    titleFr: 'Contrôles de Confidentialité & Zéro Enregistrement Personnel',
    category: 'Operations & ADRs',
    summary: 'User privacy protections preventing sensitive financial amount logging in analytics pipelines.',
    details: [
      'Conversion amount inputs are never transmitted to third-party advertising or tracker pixels.',
      'Single-click local history and favorite clearing controls.',
    ],
    architectureNotes: 'GDPR, CCPA, and Law 25 compliant data handling.',
  },
  {
    code: 'AI',
    titleEn: 'Accessibility & Screen Reader Design',
    titleFr: 'Accessibilité & Conception pour Lecteurs d’Écran',
    category: 'UX & Visualizations',
    summary: 'WCAG 2.1 AA compliant interface with dynamic live regions and high-contrast light typography.',
    details: [
      'Screen reader announcements: "1,000 US dollars equals approximately 923.45 euros at the current mid-market rate".',
      'Minimum 44px touch targets on mobile and 200% zoom text reflow support.',
    ],
    architectureNotes: 'Zero keyboard traps in currency selector dialogs.',
  },
  {
    code: 'AJ',
    titleEn: 'Performance Targets & Lazy Visualization',
    titleFr: 'Objectifs de Performance & Visualisation Différée',
    category: 'UX & Visualizations',
    summary: 'Sub-100ms conversion calculation with lightweight vector SVG rendering.',
    details: [
      'Initial converter UI loads in <300ms without blocking on heavy historical visualization charts.',
      'Zero layout shift (CLS < 0.05) with reserved ad slot dimensions.',
    ],
    architectureNotes: 'Optimized bundle size with modular component imports.',
  },
  {
    code: 'AK',
    titleEn: 'Comprehensive Testing Strategy',
    titleFr: 'Stratégie de Test Exhaustive',
    category: 'Operations & ADRs',
    summary: 'Multi-layer testing suite covering mathematical precision, provider failover, and SEO integrity.',
    details: [
      'Unit tests for direct conversion, reciprocal rate, cross rate, and zero rate edge cases.',
      'Simulated provider outages, stale payload injection, and malformed JSON recovery.',
    ],
    architectureNotes: 'Automated CI/CD validation gates.',
  },
  {
    code: 'AL',
    titleEn: 'Implementation Backlog (P0 / P1 / P2 / P3) & ADR Records',
    titleFr: 'Backlog d’Implémentation & Enregistrements ADR',
    category: 'Operations & ADRs',
    summary: 'Phased roadmap executing P0 functional core through enterprise FX capabilities.',
    details: [
      'P0: 170+ Currencies, Multi-Source Normalization, Instant Conversion, Swapping, Data Freshness Badges, and Ops Monitor.',
      'P1: Interactive SVG Time Series Charts, Deep-Dive Pair Pages, and Sharded SEO Sitemaps.',
      'P2: Rate Alerts Engine with Anti-Flapping Hysteresis and Offline PWA LKG conversions.',
      'P3: Public B2B FX API and Enterprise Data Feeds.',
      'ADR Records: ADR-FX-001 through ADR-FX-005 formalized in architecture repository.',
    ],
    architectureNotes: 'Complete functional execution verified in live preview.',
  },
];
